var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchFormRef",
                attrs: {
                  model: _vm.searchForm,
                  rules: _vm.searchFormRules,
                  "label-width": "100px",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { gutter: 24 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.shipVoyageName"
                                ) + ":",
                              prop: "vesselCode",
                            },
                          },
                          [
                            _c("gl-ship-voyage", {
                              on: {
                                handleOpenVessel: _vm.handleOpenVesselSearch,
                              },
                              model: {
                                value: _vm.searchForm,
                                callback: function ($$v) {
                                  _vm.searchForm = $$v
                                },
                                expression: "searchForm",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.prewiredLock"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.preLock,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "preLock", $$v)
                                  },
                                  expression: "searchForm.preLock",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.whetherToSendLoad"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.sendLoad,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "sendLoad", $$v)
                                  },
                                  expression: "searchForm.sendLoad",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.whetherToSendSuccess"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.loadSuccess,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "loadSuccess", $$v)
                                  },
                                  expression: "searchForm.loadSuccess",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { gutter: 24 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t("userCenter.newManifestEDI.billNumber") +
                                ":",
                            },
                          },
                          [
                            _c("el-input", {
                              on: {
                                input: _vm.loadDataByBLNo,
                                change: _vm.blNoChange,
                              },
                              model: {
                                value: _vm.searchForm.blNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "blNo", $$v)
                                },
                                expression: "searchForm.blNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.whetherToSendPreconfigured"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.sendPre,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "sendPre", $$v)
                                  },
                                  expression: "searchForm.sendPre",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.filterSuborder"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.filterSpliteBill,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "filterSpliteBill",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.filterSpliteBill",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.actualBoxBolume"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.cnt,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "cnt", $$v)
                                  },
                                  expression: "searchForm.cnt",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { gutter: 24 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.releasedOrNot"
                                ) + ":",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.clear,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "clear", $$v)
                                  },
                                  expression: "searchForm.clear",
                                },
                              },
                              _vm._l(_vm.IsYesOrNotDataEmpty, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.portOfLoading"
                                ) + ":",
                              prop: "pol",
                            },
                          },
                          [
                            _c("gl-port", {
                              model: {
                                value: _vm.searchForm.pol,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "pol", $$v)
                                },
                                expression: "searchForm.pol",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 24 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "form-item-bottom",
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "userCenter.newManifestEDI.beforeSplitting"
                                        ) + ":",
                                    },
                                  },
                                  [
                                    _c("el-checkbox", {
                                      model: {
                                        value: _vm.searchForm.scBef,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.searchForm, "scBef", $$v)
                                        },
                                        expression: "searchForm.scBef",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "form-item-bottom",
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "userCenter.newManifestEDI.afterSplitting"
                                        ) + ":",
                                    },
                                  },
                                  [
                                    _c("el-checkbox", {
                                      model: {
                                        value: _vm.searchForm.scAft,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.searchForm, "scAft", $$v)
                                        },
                                        expression: "searchForm.scAft",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "28px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.searchFormData()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "userCenter.newManifestEDI.searchButton"
                                  )
                                ) + "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-plain-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "userCenter.newManifestEDI.resetButton"
                                  )
                                ) + "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "dialogFormRulesFirstRef",
                attrs: {
                  model: _vm.dialogForm,
                  rules: _vm.dialogFormRules,
                  "label-width": "100px",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { gutter: 24 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.privilegeCode"
                                ) + ":",
                              prop: "customsId",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择", clearable: "" },
                                model: {
                                  value: _vm.dialogForm.customsId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dialogForm, "customsId", $$v)
                                  },
                                  expression: "dialogForm.customsId",
                                },
                              },
                              _vm._l(_vm.customsIdList, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.value,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.placeOfOriginArrival"
                                ) + ":",
                              prop: "districtCode",
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.dialogForm.districtCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "districtCode", $$v)
                                },
                                expression: "dialogForm.districtCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.placeOfLoading"
                                ) + ":",
                              prop: "loadPlace",
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.dialogForm.loadPlace,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "loadPlace", $$v)
                                },
                                expression: "dialogForm.loadPlace",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.placeOfLoadingCode"
                                ) + ":",
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.dialogForm.pol,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "pol", $$v)
                                },
                                expression: "dialogForm.pol",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { gutter: 24 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired form-item-bottom",
                            attrs: {
                              label:
                                _vm.$t(
                                  "userCenter.newManifestEDI.EDIFileType"
                                ) + ":",
                              prop: "porFormat",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择", clearable: "" },
                                model: {
                                  value: _vm.dialogForm.porFormat,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dialogForm, "porFormat", $$v)
                                  },
                                  expression: "dialogForm.porFormat",
                                },
                              },
                              _vm._l(_vm.ediFileTypeData, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.label
                                        : item.labelEn,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "28px",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openDialogType()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "userCenter.newManifestEDI.exportEdiButton"
                                  )
                                ) + "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getEdiFeedBack()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "userCenter.newManifestEDI.viewEdiFeedBack"
                                  )
                                ) + "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-right": "10px" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  staticClass: "upload-demo",
                                  attrs: {
                                    disabled: !_vm.uploadDisable,
                                    action: "/your-upload-endpoint",
                                    "show-file-list": true,
                                    "auto-upload": true,
                                    "http-request": _vm.uploadDgDeclare,
                                    "on-change": _vm.onChange,
                                    "before-upload": _vm.beforeFileUpload,
                                    "file-list": _vm.fileListDG,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "file",
                                      fn: function (ref) {
                                        var file = ref.file
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "file-name" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    file.name.length > 20
                                                      ? file.name.slice(0, 17) +
                                                          "..."
                                                      : file.name
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-primary",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.uploadDgDeclare },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "userCenter.newManifestEDI.uploadDgDeclare"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-right": "10px" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  staticClass: "upload-demo",
                                  attrs: {
                                    disabled: !_vm.uploadDisable,
                                    action: "/your-upload-endpoint",
                                    "show-file-list": true,
                                    "auto-upload": true,
                                    "http-request": _vm.uploadChineseMSDS,
                                    "on-change": _vm.onChange,
                                    "before-upload": _vm.beforeFileUpload,
                                    "file-list": _vm.fileListMSDS,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "file",
                                      fn: function (ref) {
                                        var file = ref.file
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "file-name" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    file.name.length > 20
                                                      ? file.name.slice(0, 17) +
                                                          "..."
                                                      : file.name
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-primary",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.uploadChineseMSDS },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "userCenter.newManifestEDI.uploadChineseMSDS"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container-new" },
          [
            _c(
              "hot-table",
              {
                ref: "hotTableCost",
                attrs: {
                  "has-tip": "",
                  "data-source": _vm.tableCostData,
                  settings: _vm.hotSettings,
                  "current-page": _vm.listQuery.currentPage,
                  "page-size": _vm.listQuery.pageSize,
                  "selection-column-title": _vm.$t("table.No"),
                  "empty-text": _vm.$t("table.emptyText"),
                },
                on: { selectionChange: _vm.hotTableSelect },
              },
              [
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "isPreReceipt",
                      title: _vm.$t(
                        "userCenter.newManifestEDI.whetherToSendPreconfigured"
                      ),
                      "class-name": "htCenter",
                      "filter-list": _vm.IsYesOrNotDataTableDigit,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "isClearReceipt",
                      title: _vm.$t("userCenter.newManifestEDI.releasedOrNot"),
                      "class-name": "htCenter",
                      "filter-list": _vm.IsYesOrNotDataTableDigit,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "isLoadReceipt",
                      title: _vm.$t(
                        "userCenter.newManifestEDI.whetherToSendLoad"
                      ),
                      "class-name": "htCenter",
                      "filter-list": _vm.IsYesOrNotDataTableDigit,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "blNo",
                    title: _vm.$t("userCenter.newManifestEDI.billNumber"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "topBlNo",
                    title: _vm.$t("userCenter.newManifestEDI.masterListNumber"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "bkNo",
                    title: _vm.$t("userCenter.newManifestEDI.bookingNumber"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "preLock",
                      title: _vm.$t("userCenter.newManifestEDI.prewiredLock"),
                      "class-name": "htCenter",
                      "filter-list": _vm.IsYesOrNotDataTableString,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "etd",
                    title: _vm.$t("userCenter.newManifestEDI.timeOfShipment"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "sendPreDate",
                    title: _vm.$t(
                      "userCenter.newManifestEDI.preAllocatedSendingTime"
                    ),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "clearDate",
                    title: _vm.$t("userCenter.newManifestEDI.clearanceTime"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "loadDate",
                    title: _vm.$t("userCenter.newManifestEDI.LoadSendingTime"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "isLoadOverTime",
                    title: _vm.$t(
                      "userCenter.newManifestEDI.WhetherToLoadOvertime"
                    ),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "cntrNum",
                    title: _vm.$t("userCenter.newManifestEDI.boxVolume"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "pol",
                    title: _vm.$t("userCenter.newManifestEDI.pol"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "vvl",
                    title: _vm.$t("userCenter.newManifestEDI.vvl"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "dgDeclareFormatter",
                    title: _vm.$t("userCenter.newManifestEDI.dgDeclare"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "chineseMSDSFormatter",
                    title: _vm.$t("userCenter.newManifestEDI.chineseMSDS"),
                    "class-name": "htCenter",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "pagePanel",
              staticStyle: { "text-align": "left" },
              attrs: {
                total: _vm.listQuery.total,
                page: _vm.listQuery.currentPage,
                limit: _vm.listQuery.pageSize,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "currentPage", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "pageSize", $event)
                },
                pagination: _vm.searchFormData,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.newManifestEDI.chooseEdi"),
            visible: _vm.openDialog1,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openDialog1 = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dialogForm1",
                      attrs: {
                        model: _vm.dialogForm,
                        rules: _vm.dialogRules,
                        "label-width": "170px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.descriptionReasonChange"
                              ) + ":",
                            prop: "changeReson",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogForm.changeReson,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "changeReson", $$v)
                              },
                              expression: "dialogForm.changeReson",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.changeRequestContactName"
                              ) + ":",
                            prop: "changeContactName",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogForm.changeContactName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dialogForm,
                                  "changeContactName",
                                  $$v
                                )
                              },
                              expression: "dialogForm.changeContactName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.changeRequestContactPhone"
                              ) + ":",
                            prop: "changeContactTel",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogForm.changeContactTel,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dialogForm,
                                  "changeContactTel",
                                  $$v
                                )
                              },
                              expression: "dialogForm.changeContactTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.openDialog1 = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.newManifestEDI.chooseEdi"),
            visible: _vm.openDialog2,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openDialog2 = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dialogForm2",
                      attrs: {
                        model: _vm.dialogForm,
                        rules: _vm.dialogRules,
                        "label-width": "170px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.shipVoyageName"
                              ) + ":",
                            prop: "vesselCode",
                          },
                        },
                        [
                          _c("gl-ship-voyage", {
                            on: {
                              handleOpenVessel: _vm.handleOpenVesselDialog2,
                            },
                            model: {
                              value: _vm.dialogForm,
                              callback: function ($$v) {
                                _vm.dialogForm = $$v
                              },
                              expression: "dialogForm",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.descriptionReasonChange"
                              ) + ":",
                            prop: "changeReson",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogForm.changeReson,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "changeReson", $$v)
                              },
                              expression: "dialogForm.changeReson",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.changeRequestContactName"
                              ) + ":",
                            prop: "changeContactName",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogForm.changeContactName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dialogForm,
                                  "changeContactName",
                                  $$v
                                )
                              },
                              expression: "dialogForm.changeContactName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.changeRequestContactPhone"
                              ) + ":",
                            prop: "changeContactTel",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.dialogForm.changeContactTel,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dialogForm,
                                  "changeContactTel",
                                  $$v
                                )
                              },
                              expression: "dialogForm.changeContactTel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.openDialog2 = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.newManifestEDI.chooseEdi"),
            visible: _vm.openDialog3,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openDialog3 = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dialogForm3",
                      attrs: {
                        model: _vm.dialogForm,
                        rules: _vm.dialogRules,
                        "label-width": "170px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.originalReleaseShipVoyageName"
                              ) + ":",
                            prop: "vesselCode",
                          },
                        },
                        [
                          _c("gl-ship-voyage", {
                            on: {
                              handleOpenVessel: _vm.handleOpenVesselDialog3,
                            },
                            model: {
                              value: _vm.dialogForm,
                              callback: function ($$v) {
                                _vm.dialogForm = $$v
                              },
                              expression: "dialogForm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.openDialog3 = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.newManifestEDI.chooseEdi"),
            visible: _vm.openDialog4,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openDialog4 = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dialogForm4",
                      attrs: {
                        model: _vm.dialogForm,
                        rules: _vm.dialogRules,
                        "label-width": "170px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.fileTypeListForm"
                              ) + ":",
                            prop: "reportType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.dialogForm.reportType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "reportType", $$v)
                                },
                                expression: "dialogForm.reportType",
                              },
                            },
                            _vm._l(_vm.fileTypeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label:
                                    _vm.language === "zh"
                                      ? item.label
                                      : item.labelEn,
                                  value: item.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "5" ||
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.changeOfManifestReason"
                                  ) + ":",
                                prop: "deleteReason",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.dialogForm.deleteReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dialogForm,
                                        "deleteReason",
                                        $$v
                                      )
                                    },
                                    expression: "dialogForm.deleteReason",
                                  },
                                },
                                _vm._l(_vm.deleteReasonList, function (item) {
                                  return _c("el-option", {
                                    key: item.codeValue,
                                    attrs: {
                                      label:
                                        _vm.language === "zh"
                                          ? item.displayValueCn
                                          : item.displayValue,
                                      value: item.codeValue,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.timeOfShipment"
                              ) + ":",
                            prop: "loadShipTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: { type: "datetime" },
                            model: {
                              value: _vm.dialogForm.loadShipTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "loadShipTime", $$v)
                              },
                              expression: "dialogForm.loadShipTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "5" ||
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.descriptionReasonChange"
                                  ) + ":",
                                prop: "changeReson",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.dialogForm.changeReson,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dialogForm, "changeReson", $$v)
                                  },
                                  expression: "dialogForm.changeReson",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "5" ||
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.changeRequestContactName"
                                  ) + ":",
                                prop: "changeContactName",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.dialogForm.changeContactName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dialogForm,
                                      "changeContactName",
                                      $$v
                                    )
                                  },
                                  expression: "dialogForm.changeContactName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "5" ||
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.changeRequestContactPhone"
                                  ) + ":",
                                prop: "changeContactTel",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.dialogForm.changeContactTel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dialogForm,
                                      "changeContactTel",
                                      $$v
                                    )
                                  },
                                  expression: "dialogForm.changeContactTel",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.openDialog4 = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.newManifestEDI.chooseEdi"),
            visible: _vm.openDialog5,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openDialog5 = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dialogForm5",
                      attrs: {
                        model: _vm.dialogForm,
                        rules: _vm.dialogRules,
                        "label-width": "170px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.fileTypeListForm"
                              ) + ":",
                            prop: "reportType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.dialogForm.reportType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "reportType", $$v)
                                },
                                expression: "dialogForm.reportType",
                              },
                            },
                            _vm._l(_vm.fileTypeList5, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label:
                                    _vm.language === "zh"
                                      ? item.label
                                      : item.labelEn,
                                  value: item.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                prop: "deleteReason",
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.changeOfManifestReason"
                                  ) + ":",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.dialogForm.deleteReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dialogForm,
                                        "deleteReason",
                                        $$v
                                      )
                                    },
                                    expression: "dialogForm.deleteReason",
                                  },
                                },
                                _vm._l(_vm.deleteReasonList, function (item) {
                                  return _c("el-option", {
                                    key: item.codeValue,
                                    attrs: {
                                      label:
                                        _vm.language === "zh"
                                          ? item.displayValueCn
                                          : item.displayValue,
                                      value: item.codeValue,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "userCenter.newManifestEDI.timeOfShipment"
                              ) + ":",
                            prop: "loadShipTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: { type: "datetime" },
                            model: {
                              value: _vm.dialogForm.loadShipTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "loadShipTime", $$v)
                              },
                              expression: "dialogForm.loadShipTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                prop: "changeReson",
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.descriptionReasonChange"
                                  ) + ":",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.dialogForm.changeReson,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dialogForm, "changeReson", $$v)
                                  },
                                  expression: "dialogForm.changeReson",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                prop: "changeContactName",
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.changeRequestContactName"
                                  ) + ":",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.dialogForm.changeContactName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dialogForm,
                                      "changeContactName",
                                      $$v
                                    )
                                  },
                                  expression: "dialogForm.changeContactName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogForm.reportType == "3"
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "form-item-bottom",
                              attrs: {
                                prop: "changeContactTel",
                                label:
                                  _vm.$t(
                                    "userCenter.newManifestEDI.changeRequestContactPhone"
                                  ) + ":",
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.dialogForm.changeContactTel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dialogForm,
                                      "changeContactTel",
                                      $$v
                                    )
                                  },
                                  expression: "dialogForm.changeContactTel",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.openDialog5 = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
          selectionChange: _vm.selectionChangeSailSchedule,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }